<script>
import keviApi from "../keviApi.js";

export default {
    name: "places-base",
    methods: {
        removeAccents(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
    },
    computed: {
        places: function () {
            return this.$store.state.places;
        },
        filterPlaces() {
            let places = this.places;
            if (this.search) {
                const searchNormalized = this.removeAccents(
                    this.search.toLowerCase(),
                );
                places = Object.assign(
                    [],
                    places.filter((pl) =>
                        this.removeAccents(pl.name.toLowerCase()).includes(
                            searchNormalized,
                        ),
                    ),
                );
            }

            if (this.filter_selected_place) {
                places = places.filter(
                    (pl) => pl.id !== this.filter_selected_place.id,
                );
            }

            if (
                this.filter_selected_place &&
                !places
                    .map((pl) => pl.id)
                    .includes(this.filter_selected_place.id)
            ) {
                places.unshift(this.filter_selected_place);
            }
            return places;
        },
    },
    data() {
        return {
            search: null,
            filter_selected_place: null,
        };
    },
    created: function () {
        var options = keviApi.getOptions("places");
        if (this.user.global_admin) {
            this.setState("loading");
            this.$http(options).then(function (response) {
                if (response.status === 200) {
                    this.setState("ready");
                    this.$store.commit("setPlaces", response.body);
                }
            });
        } else {
            this.$store.commit("setPlaces", []);
            this.setState("ready");
        }

        if (this.$store.state.place) {
            this.filter_selected_place = Object.assign(
                {},
                this.$store.state.place,
            );
        }
    },
};
</script>
